import {
  QUICK_ADD
} from 'permissions/actions'

export const LEAD_SOURCE = '@@permissions/policy/leadSource'

export default {
  [QUICK_ADD]: (user, options) => !!user.is_account_admin && !user.read_only
}
